import { render, staticRenderFns } from "./CrmUserNew.vue?vue&type=template&id=d52a30b2&scoped=true&"
import script from "./CrmUserNew.vue?vue&type=script&lang=js&"
export * from "./CrmUserNew.vue?vue&type=script&lang=js&"
import style0 from "./CrmUserNew.vue?vue&type=style&index=0&id=d52a30b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52a30b2",
  null
  
)

export default component.exports